// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactNavBar-cls1_dKH","cls2":"ImpactNavBar-cls2_hCg ImpactNavBar-cls1_dKH"};